function setVisible(state, isVisible) {
  state.isVisible = isVisible;
}

function setProposition(state, proposition) {
  state.proposition = proposition;
}

function setReboostClosesAt(state, closesAt) {
  state.reboostClosesAt = closesAt;
}

export default { setVisible, setProposition, setReboostClosesAt };
